// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bgv_a","AdSlotBranding__desktop":"bgv_b","AdSlotBranding__mobile":"bgv_c"};